import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AsmResetPasswordService } from '../asm-reset-password.service';
import { RoutingService } from '@spartacus/core';
@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  userAgentDataSubscription: any;
  sendMailSubscription: any;
  userAgentList: any= [];
  userEmailId: any = '';
  isNoResults: boolean = false;
  selectedUser: any = {};
  isDisabled: boolean = true;
  searchDisabled: boolean = true;
  constructor(
    private readonly cd: ChangeDetectorRef,
    private router: Router,
    private readonly service: AsmResetPasswordService,
    private readonly route: RoutingService,
  ) { }

  ngOnInit(): void {
  }

  validateText() {
    this.searchDisabled = this.userEmailId.length > 2 ? false : true;
    this.cd.detectChanges();
  }
  
  getUsersData() {
    if(this.userEmailId.length > 2 ) {
      this.sendMailSubscription = this.service.getUserAgent({fields: 'DEFAULT', currentPage: 20, pageSize: 20, timeFrame: '3', form: this.userEmailId}).subscribe(res => {
        if(res && res['entries'] && res['entries'].length > 0){
          //success
          this.userAgentList = res['entries'];
          this.isNoResults = false;
          this.cd.detectChanges()
        }
        else{
          //error
          this.userAgentList = [];
          this.isNoResults = true;
          this.cd.detectChanges();
        }
      });
    }
  }

  radioSelected(user:any){
    this.selectedUser = user;
    this.isDisabled = false;
    this.cd.detectChanges();
  }

  resetPassword() {
    const userDetails = {
      email: this.selectedUser.email,
      name: this.selectedUser.name, 
      passwordQuestion:this.selectedUser.passwordQuestion,
      passwordAnswer:this.selectedUser.passwordAnswer,
      accountNumber:this.selectedUser.customerId,
      forgotUsername:false,
      forgotPassword:false,
      resetPassword:true,
      resetPasswordEmailSent:false,
      recoverUsernameEmailSent:false
    }
    this.service.sendResetMail(userDetails);
    this.sendMailSubscription = this.service.sendUserMail$.subscribe((res) => {
      try {
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        this.router.navigate(['/salesAgentResetPasswordConfirmationPage']);
      }
      catch (error){
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        this.router.navigate(['/salesAgentResetPasswordFailurePage']);
      }
    })
  }

  navigateToSalesAgentResetPassword() {
    this.route.goByUrl('/salesAgentResetPassword');
  }

  navigateToRstPswdEmail() {
    this.route.goByUrl('/salesAgentResetPassword/sendResetPasswordEmail')
  }

  ngOnDestroy() {
    this.userAgentDataSubscription?.unsubscribe();
    this.sendMailSubscription?.unsubscribe();
  }

}
